import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

import { NotificationCard } from 'core/components/notification-card';
import { useStore } from 'core/store/store.mobx';
import { useRouteHelper } from 'core/hooks/use-route-helper';
import NotificationIconGreen from 'core/assets/svg/ic-info-dark.svg';
import ResetIcon from 'core/assets/svg/ic-reset.svg';

import { getDataValue, overridableHomeFields } from './overridable-fields';
import useStyles from './data-source-mismatch-notification.styles';

// Gentle callout shown on the offer page when an agent enters a home characteristic that differs from
// what our data indicates. We rate on the agent's value; this just asks them to be sure, and bind raises
// a Front ticket where the change can affect eligibility (github issues #26706, #35350). Originally the
// above-ground sqft callout (#25361).
const DataSourceMismatchNotification = ({ id, name }) => {
  const classes = useStyles();
  const { offer: store } = useStore();
  const { values, setFieldValue, setFieldTouched } = useFormikContext();
  const { inOfferEditRoute } = useRouteHelper();

  const dataValue = getDataValue(store.offer, name);
  if (!inOfferEditRoute || dataValue == null || values[id]?.[name] === dataValue) {
    return null;
  }

  const { label, resetLabel, describe = (value) => value } = overridableHomeFields[name];

  return (
    <NotificationCard
      type="light"
      className={classes.cardStyling}
      iconByHeader
      icon={NotificationIconGreen}
      iconSize="icon16Bold"
      header={`The ${label} has been modified from its original verified value of ${describe(dataValue)}, which was obtained from a third-party data source.`}
    >
      <Grid container className={classes.notificationText}>
        Please ensure the information entered is accurate. If found incorrect, it will be updated, which may lead to a
        premium increase.
        <Grid container className={classes.buttonContainer}>
          <Button
            color="secondary"
            variant="text"
            className={classes.button}
            onClick={() => {
              setFieldValue(`${id}.${name}`, dataValue);
              setFieldTouched(`${id}.${name}`, true);
            }}
          >
            <img src={ResetIcon} className={classes.iconStyle} alt="" />
            {resetLabel}
          </Button>
        </Grid>
      </Grid>
    </NotificationCard>
  );
};

DataSourceMismatchNotification.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.oneOf(Object.keys(overridableHomeFields)).isRequired
};

export default DataSourceMismatchNotification;
